import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import forms from './forms'

const namespaced = true

const defaultMeta =  {
  paginate: true,
  current_page: 1,
  desc: false,
  last_page: null,
  order: 'order',
  per_page: null,
  search: null,
  total: null
}

const _defaultView = 'all'
const _archivedView = 'archived'
const _clientView = 'client'
const _favoritesView = 'favorites'

const state = {
  current: null,
  _defaultView,
  _archivedView,
  _clientView,
  _favoritesView,
  complete: {
    index: {},
    ids: []
  },
  views: {
    [_defaultView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: false,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [_archivedView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: true,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [_clientView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        active: true,
        archived: false,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [_favoritesView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: false,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    }
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
  modules: {
    forms
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/topics/index.js